import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IGetAiBotSettingsDTO,
  IGetAiBotSettingsResponse,
  IUpdateAiBotSettingsDTO,
  IUpdateAiBotSettingsResponse,
} from '@/models/aiBotSettings.model';
import { IApiError } from '@/models/apiError.model';
import { formatApiError } from '@/utils';
import { AiBotConfigAPI } from '@/api';
import { SLICE_NAME } from './models';

export const getAiBotSettings = createAsyncThunk<
  IGetAiBotSettingsResponse,
  IGetAiBotSettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getAiBotSettings`,
  async (params) => {
    const response = await AiBotConfigAPI.getAiBotSettings(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateAiBotSettings = createAsyncThunk<
  IUpdateAiBotSettingsResponse,
  IUpdateAiBotSettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateAiBotSettings`,
  async (data) => {
    const response = await AiBotConfigAPI.updateAiBotSettings(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
